// export const BASE_URL = "http://localhost:3002/api";
// export const CDN_BASE_URL = "http://localhost:3002/";

export const BASE_URL = "https://api.epskan.com/api";
export const CDN_BASE_URL = "https://api.epskan.com/";

// export const CDN_BASE_URL = "http://localhost:3001/";
// export const BASE_URL = "http://localhost:3001/api";
